<template>
    <v-row>
        <div ref="talkjs" style="width: 100%; height: 80vh">
            <i>Loading chat...</i>
        </div>
    </v-row>
</template>

<script>
import { UserServicesToggleBrowserNotifications } from "@services/UserServices";

export default {
    methods: {
        initInbox() {
            if (this.talkjsSession && this.$refs.talkjs) {
                const inbox = this.talkjsSession.createInbox({
                    theme: "tips4y_lightmode_desktop",
                });

                this.talkjsSession.setDesktopNotificationEnabled(
                    this.userAuth.browserNotifications
                );

                inbox.onDesktopNotificationToggled((evt) => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        true
                    );
                    UserServicesToggleBrowserNotifications(
                        this.userAuth.userId,
                        { browserNotifications: evt.isEnabled }
                    )
                        .then(() => {
                            let state = this.userAuth;
                            state.browserNotifications = evt.isEnabled;
                            this.$store.commit("auth/setState", state);
                        })
                        .catch((error) => {
                            this.$requestStatus.checkRequestStatus(
                                error.response.status,
                                this.$route.name
                            );
                        })
                        .finally(() => {
                            this.$store.commit(
                                "loadings/setStateLoadingTemplate",
                                false
                            );
                        });
                });

                inbox.mount(this.$refs.talkjs);
            }
        },
    },
    computed: {
        talkjsSession() {
            return this.$store.getters["talkjs/getSession"];
        },
        userAuth() {
            return this.$store.getters["auth/getState"];
        },
    },
    watch: {
        talkjsSession: {
            handler: function () {
                this.initInbox();
            },
            immediate: true,
        },
    },
    mounted() {
        this.initInbox();
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
</style>